module.exports = __webpack_public_path__ + "static/team1-e3b7b60861383961b605472a6a9a7bc6.png";